import { Card } from "./Card/Card";
import { useContext, useEffect, useState } from "react";
import ShowToast from "../../utils/ShowToast";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AuthContext from "../../Context/auth/AuthContext";
import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  Divider,
  Card as MUICard,
  Paper,
} from "@mui/material";
import MethodGet from "../../config/Service";
import CartContext from "../../Context/Cart/CartContext";
import FormatCurrency from "../../utils/FormatCurrency";

export const Cart = () => {
  const { cart, setCart } = useContext(CartContext);
  const cartlocal = localStorage.getItem("cart");
  const storedCoupon = JSON.parse(localStorage.getItem("appliedCoupon")) || null;
  const { autenticado } = useContext(AuthContext);
  const [coupon, setCoupon] = useState(storedCoupon ? storedCoupon.code : "");
  const [couponData, setCouponData] = useState(storedCoupon);
  const [discount, setDiscount] = useState(storedCoupon ? storedCoupon.discount : 0);
  const [businessRoules, setBusinessRoules] = useState(false);

  // Función para calcular todos los valores del carrito
  const calculateCartTotals = () => {
    let subtotalOriginal = 0;
    let descuentoDirecto = 0;
    let descuentoCupon = 0;
    let totalFinal = 0;
    let precioSinDescuentoDirecto = 0;
    let precioConDescuentoDirecto = 0;

    cart?.forEach(item => {
      const precioOriginal = item.price * item.cantidad;
      subtotalOriginal += precioOriginal;

      // Si el producto tiene descuento directo (price_with_discount)
      if (item.price_with_discount > 0) {
        const precioConDescuentoItem = item.price_with_discount * item.cantidad;
        precioConDescuentoDirecto += precioConDescuentoItem;
        descuentoDirecto += precioOriginal - precioConDescuentoItem;
        totalFinal += precioConDescuentoItem;
      } else {
        // Si no tiene descuento directo, aplicamos el cupón si existe
        precioSinDescuentoDirecto += precioOriginal;
        const descuentoCuponItem = (precioOriginal * discount) / 100;
        descuentoCupon += descuentoCuponItem;
        totalFinal += precioOriginal - descuentoCuponItem;
      }
    });

    return {
      subtotalOriginal,
      descuentoDirecto,
      descuentoCupon,
      totalFinal,
      descuentoTotal: descuentoDirecto + descuentoCupon,
      precioSinDescuentoDirecto,
      precioConDescuentoDirecto
    };
  };

  const totals = calculateCartTotals();

  // Efecto para manejar reglas de negocio
  useEffect(() => {
    if (totals.precioSinDescuentoDirecto > 1499.99) {
      const url = `/distribucion/Discount/${totals.precioSinDescuentoDirecto}`;

      MethodGet(url)
        .then((res) => {
          // Limpiar cualquier cupón aplicado previamente
          if (couponData) {
            setCouponData(null);
            setCoupon("");
            localStorage.removeItem("appliedCoupon");
          }

          setDiscount(res.data.discount || 0);
          setBusinessRoules(true);

          // ShowToast(
          //   "success",
          //   `¡Descuento automático aplicado! Descuento del ${res.data.discount}% por compra mayor a $1,499.99`
          // );
        })
        .catch((error) => {
          console.error("Error fetching discount:", error);
          setBusinessRoules(false);
        });
    } else {
      // Solo resetear reglas de negocio, mantener cupón si existe
      setBusinessRoules(false);

      // Si no hay reglas de negocio y no hay cupón, resetear descuento
      if (!couponData && !storedCoupon) {
        setDiscount(0);
      }
    }
  }, [totals.precioSinDescuentoDirecto]);

  // Efecto para cargar cupón del localStorage al inicializar
  useEffect(() => {
    const storedCouponFromStorage = JSON.parse(localStorage.getItem("appliedCoupon"));
    if (storedCouponFromStorage && !businessRoules) {
      setCouponData(storedCouponFromStorage);
      setDiscount(storedCouponFromStorage.discount);
      setCoupon(storedCouponFromStorage.code);
    }
  }, [cart, businessRoules]);

  const eliminarProducto = (productId) => {
    const todosProducto = cart.filter((c) => c.product_id !== productId);
    setCart(todosProducto);
  };

  const handleCouponApply = async (e) => {
    e.preventDefault();

    if (!coupon.trim()) {
      ShowToast("error", "Atención", "Por favor ingresa un código de cupón");
      return;
    }

    try {
      const res = await MethodGet(`/distribucion/couponValidity?code=${coupon}`);

      if (res.data.coupon) {
        setCouponData(res.data.coupon);
        setDiscount(res.data.coupon.discount);
        localStorage.setItem("appliedCoupon", JSON.stringify(res.data.coupon));
        ShowToast(
          "success",
          "Correcto",
          `Cupón aplicado! Descuento del ${res.data.coupon.discount}%`
        );
      } else {
        setDiscount(0);
        setCouponData(null);
        localStorage.removeItem("appliedCoupon");
        ShowToast(
          "error",
          "Atención",
          "El código de cupón no es válido o no existe"
        );
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      setDiscount(0);
      setCouponData(null);
      localStorage.removeItem("appliedCoupon");
      ShowToast("error", "Atención", "Error al validar el cupón");
    }
  };

  const handleProductQuantity = (change, cantidad, product_id, stock, discount = 0) => {
    const updatedCart = cart.map((item) => {
      if (item.product_id === product_id) {
        const newCantidad =
          change === "increment"
            ? Math.min(cantidad + 1, stock)
            : Math.max(cantidad - 1, 1);

        let newFinalPrice;
        if (item.price_with_discount > 0) {
          newFinalPrice = item.price_with_discount * newCantidad;
        } else {
          newFinalPrice = item.price * newCantidad;
        }

        return {
          ...item,
          cantidad: newCantidad,
          final_price: newFinalPrice,
        };
      }
      return item;
    });
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const handleRemoveCoupon = () => {
    setCoupon("");
    setDiscount(0);
    setCouponData(null);
    localStorage.removeItem("appliedCoupon");
    ShowToast(
      "success",
      "Cupón eliminado",
      "El cupón ha sido eliminado correctamente"
    );
  };

  // Función para determinar si mostrar el formulario de cupón
  const shouldShowCouponForm = () => {
    return (
      autenticado &&
      cart.length > 0 &&
      !businessRoules && // No mostrar si hay reglas de negocio aplicadas
      !couponData &&     // No mostrar si ya hay un cupón aplicado
      totals.precioSinDescuentoDirecto <= 1499.99 && // Solo para montos menores a 1500
      totals.precioSinDescuentoDirecto > 0 // Solo si hay productos sin descuento directo
    );
  };

  // Función para determinar si mostrar el cupón aplicado
  const shouldShowAppliedCoupon = () => {
    return (
      autenticado &&
      couponData &&
      !businessRoules
    );
  };

  return (
    <Box sx={{ p: 1 }}>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            {cart.length > 0 ? (
              <div style={{ maxHeight: "650px", overflowY: "auto" }}>
                {cart.map((cart) => (
                  <MUICard key={cart.product_id} sx={{ mb: 2, p: 1 }}>
                    <Card
                      cart={cart}
                      onChangeQuantity={(change, cantidad) =>
                        handleProductQuantity(
                          change,
                          cantidad,
                          cart.product_id,
                          cart.stock,
                          cart.discount
                        )
                      }
                      eliminarProducto={() => eliminarProducto(cart.product_id)}
                    />
                  </MUICard>
                ))}
              </div>
            ) : (
              <Typography variant='h6' align='center'>
                No hay productos en el carrito
              </Typography>
            )}
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* Sección de cupones */}
            {autenticado && (
              <Box sx={{ mb: 3 }}>
                {/* Mostrar cupón aplicado */}
                {shouldShowAppliedCoupon() && (
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="body1">
                      Cupón aplicado: <strong>{couponData.code}</strong> ({couponData.discount}%)
                    </Typography>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={handleRemoveCoupon}
                    >
                      Eliminar
                    </Button>
                  </Box>
                )}

                {/* Mostrar formulario de cupón */}
                {shouldShowCouponForm() && (
                  <form onSubmit={handleCouponApply}>
                    <TextField
                      fullWidth
                      placeholder="Ingresa el código de promoción"
                      value={coupon}
                      onChange={(e) => setCoupon(e.target.value)}
                      sx={{ mb: 2 }}
                    />
                    <Button
                      variant="contained"
                      type="submit"
                      fullWidth
                      sx={{
                        backgroundColor: "#801f56",
                        "&:hover": { backgroundColor: "#801f56" },
                      }}
                    >
                      Aplicar cupón
                    </Button>
                  </form>
                )}

                {/* Mensaje informativo para reglas de negocio */}
                {businessRoules && totals.precioSinDescuentoDirecto > 1499.99 && (
                  <Typography variant="body2" sx={{ color: "green", fontWeight: "bold", textAlign: "center", p: 2, bgcolor: "#f0f8f0", borderRadius: 1 }}>
                    🎉 ¡Descuento automático del {discount}% aplicado!
                    <br />
                    <Typography variant="caption" display="block" sx={{ mt: 1, fontStyle: "italic" }}>
                      No es posible aplicar cupones adicionales con este descuento.
                    </Typography>
                  </Typography>
                )}
              </Box>
            )}

            <Divider />

            {/* Resumen de totales */}
            <Box sx={{ mt: 3 }}>
              {totals.precioSinDescuentoDirecto > 0 && (
                <Typography variant='body1'>
                  Subtotal productos sin descuento directo: <strong>${totals.precioSinDescuentoDirecto.toFixed(2)}</strong>
                </Typography>
              )}

              {totals.precioConDescuentoDirecto > 0 && (
                <Typography variant='body1'>
                  Subtotal productos con descuento directo: <strong>${(totals.precioConDescuentoDirecto + totals.descuentoDirecto).toFixed(2)}</strong>
                </Typography>
              )}

              <Typography variant='body1'>
                Subtotal Global: <strong>${totals.subtotalOriginal.toFixed(2)}</strong>
              </Typography>

              {/* Mostrar descuento por reglas de negocio */}
              {businessRoules && totals.descuentoCupon > 0 && (
                <Typography variant="body1" sx={{ color: "green" }}>
                  Descuento por reglas ({discount}%):{" "}
                  <strong>-${totals.descuentoCupon.toFixed(2)}</strong>
                </Typography>
              )}

              {/* Mostrar descuento de cupón */}
              {totals.descuentoCupon > 0 &&
                totals.precioSinDescuentoDirecto <= 1499.99 &&
                !businessRoules &&
                couponData && (
                  <Typography variant="body1" sx={{ color: "green" }}>
                    Descuento de cupón ({discount}%):{" "}
                    <strong>-${totals.descuentoCupon.toFixed(2)}</strong>
                  </Typography>
                )}

              {/* Mostrar descuento directo */}
              {totals.descuentoDirecto > 0 && (
                <Typography variant='body1' sx={{ color: 'green' }}>
                  Descuento directo: <strong>-${totals.descuentoDirecto.toFixed(2)}</strong>
                </Typography>
              )}

              {/* Mostrar descuento total */}
              {totals.descuentoTotal > 0 && (
                <Typography variant='body1' sx={{ color: 'green', fontWeight: 'bold' }}>
                  Descuento total: <strong>-${totals.descuentoTotal.toFixed(2)}</strong>
                </Typography>
              )}

              <Typography variant='h6' sx={{ mt: 2, borderTop: '1px solid #ccc', pt: 1 }}>
                Total: <strong>{FormatCurrency(totals.totalFinal)}</strong>
              </Typography>
            </Box>

            {/* Botones de acción */}
            <Box sx={{ mt: 3 }}>
              {autenticado ? (
                <Link to='/pagar-carrito'>
                  <Button
                    variant='contained'
                    fullWidth
                    disabled={cart.length === 0}
                    sx={{
                      backgroundColor: "#801f56",
                      "&:hover": { backgroundColor: "#801f56" },
                    }}
                  >
                    Continuar
                  </Button>
                </Link>
              ) : (
                <Link to='/iniciar-sesion'>
                  <Button
                    variant='contained'
                    fullWidth
                    sx={{
                      backgroundColor: "#801f56",
                      "&:hover": { backgroundColor: "#801f56" },
                    }}
                  >
                    Iniciar sesión para pagar
                  </Button>
                </Link>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};